import type { SlateLeaf } from '@atlas/renderer';

export default function isSameLeafFormat(leafA: SlateLeaf, leafB: SlateLeaf): boolean {
    const leafAKeys = Object.keys(leafA) as Array<keyof SlateLeaf>;
    const leafBKeys = Object.keys(leafB) as Array<keyof SlateLeaf>;

    if (leafAKeys.length !== leafBKeys.length) return false;

    return leafAKeys.every((key) => key === 'text' || leafA[key] === leafB[key]);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isSameLeafFormat', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
